import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import DashboardHeader from "./header/header";
import DashboardSidebar from "./sidebar/sidebar";


export const DashboardLayout: React.FC = () => {
    // Supprimez isMobileMenuOpen et son effet (plus besoin)
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div className="flex h-screen overflow-hidden bg-gray-50 font-poppins">
            {/* Sidebar : visible sur desktop, cachée sur mobile */}
            <DashboardSidebar />

            <div className="flex flex-col w-full overflow-hidden">
                <header className="z-30 flex items-center h-16 min-w-full px-4 border-b shadow-sm bg-background">
                    {/* Le bouton hamburger a disparu, car remplacé par le bottom bar */}
                    <DashboardHeader />
                </header>

                <main className="h-screen p-4 overflow-y-auto bg-gray-50 pb-20 md:pb-4">
                    <Outlet />
                </main>

                
            </div>
        </div>
    );
};